var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-select",
        {
          ref: "selectUpResId",
          model: {
            value: _vm.value,
            callback: function ($$v) {
              _vm.value = $$v
            },
            expression: "value",
          },
        },
        [
          _c("el-option", {
            key: "upResId",
            attrs: { hidden: "", value: _vm.value, label: _vm.value },
          }),
          _c("el-tree", {
            attrs: {
              data: _vm.data,
              props: _vm.defaultProps,
              "expand-on-click-node": false,
              "check-on-click-node": true,
            },
            on: { "node-click": _vm.handleNodeClick },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ node }) {
                  return _c("span", { staticClass: "custom-tree-node" }, [
                    _c(
                      "span",
                      {
                        staticClass: "treeLabel",
                        class: { active: node.label === _vm.value },
                        attrs: { title: node.label },
                      },
                      [_vm._v(" " + _vm._s(node.label) + " ")]
                    ),
                  ])
                },
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }